import { checkingOrder } from "@/api/deposito";
import useTrack from "@/hooks/useTrack";
const { track2Platform, trackName } = useTrack();
let intervalId: any = true;
export default async function useTrackPayResult (orderNo: string, times: number = 200, interval: number = 5000) {
  if(!intervalId) return;
  console.log('track pay result', orderNo)
  const { code, data } = await checkingOrder({ orderNo }).catch(() => ({code: 0, data: null}))

  if (code === 1 && data) {
    if (data.status === "PayFailed" || data.status === "PullFailed") {
      console.log('PullFailed', data)
      return
    }

    if (data.status === "ForcedSuccess" || data.status === "Paid") {
      if (data.firstFlag) {
        // 首充
        track2Platform(trackName.Purchase, {
          value: data.realAmt,
          currency: data.currency,
          product_catalog_id: data.id,
        });
      } else  {
        // 复冲
        track2Platform(trackName.Recharge, {
          value: data.realAmt,
          currency: data.currency,
          product_catalog_id: data.id,
        });
      }

      return
    }
  }

  setTimeout(() => {
    useTrackPayResult(orderNo, times - 1);
  }, interval);
}


export const stopTrackPayResult = () => {
  intervalId = false;
}